export default __webpack_public_path__ + "static/media/link_external.4e6b4781.svg";